import {
  Box,
  Button,
  Card,
  Drawer,
  Group,
  ScrollArea,
  Title
} from '@mantine/core'
import { useViewportSize } from '@mantine/hooks'
import { IconArrowLeft } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

const HEADER_HEIGHT = 64

type ListItemDrawerProps = {
  opened: boolean
  title: ReactNode
  children: ReactNode
  size?: string | number
  closeOnEscape?: boolean
  onClose: () => void
}

export const ListItemDrawer = ({
  opened,
  title,
  children,
  size = '80%',
  closeOnEscape,
  onClose
}: ListItemDrawerProps) => {
  const { height } = useViewportSize()

  return (
    <Drawer.Root
      opened={opened}
      position="right"
      size={size}
      closeOnEscape={closeOnEscape}
      onClose={onClose}
    >
      <Drawer.Overlay />

      <Drawer.Content>
        <Card padding="lg">
          <Card.Section h={HEADER_HEIGHT} py={14} withBorder inheritPadding>
            <Group
              align="center"
              gap="xl"
              wrap="nowrap"
              justify="space-between"
            >
              <Button
                miw={160}
                variant="outline"
                radius="xl"
                leftSection={<IconArrowLeft size={16} />}
                onClick={onClose}
              >
                <FormattedMessage id="general.backToList" />
              </Button>

              <Title order={4} fz={16}>
                {title}
              </Title>

              <Box w={160}>&nbsp;</Box>
            </Group>
          </Card.Section>

          <Card.Section>
            <ScrollArea h={height - HEADER_HEIGHT}>
              <Box p="lg">{children}</Box>
            </ScrollArea>
          </Card.Section>
        </Card>
      </Drawer.Content>
    </Drawer.Root>
  )
}
